











































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import uuifComponent from '@/shared/uuifComponent';
import { TableColumnConfig, TableEntry } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { DateTimePickerConfig, SwDatetimePicker } from '@sonicwall/unified-ui-framework/src/shared/sw-datetime-picker';
import { SelectableDatesRangeType } from '@sonicwall/unified-ui-framework/src/shared/sw-datetime-picker/types';
import { InfoState } from '@/core';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';

const cssPrefix = 'process-nfr-request';

@Component({
  components: {
    ...uuifComponent,
    SwDatetimePicker,
    SwCheckbox,
  },
})
export default class ProcessNfrDialog extends SwExtendedVue {
  @Prop()
  showProcessNfrDialog: boolean;
  @Prop()
  data: any;
  submitted : boolean = false;
  cssPrefix =  cssPrefix;
  dateValue = '';
  nfrProcessData : TableEntry[] = [];
  nfrProcessCompleteData : TableEntry[] = [];
  nfrProcessCompleteMsg : string = '';
  requestExp : boolean = false;
  todayDate = new Date();
  nfrProcessComplete : boolean =  false;
  selectableDateRangeType : SelectableDatesRangeType = {
    startDate :  this.todayDate.toString(),
  };
  singlePickerConfig: DateTimePickerConfig = {
    placeholder: 'select date',
    dateFormat: 'MM/DD/YYYY',
    onDayClick: this.onDayClick2,
    selectableDatesRange : this.selectableDateRangeType,
    hidePreAndNextMonthDates: true,
  };
  nfrProcessColumConfig:  TableColumnConfig[] = [{
    key : 'index',
    type : 'index',
  },
  {
    key: 'nfrFriendlyName',
    dataKey : 'nfrFriendlyName',
    title : this.$t('products.name')
    .toString(),
  },
  {
    key: 'nfrSerialNumber',
    dataKey : 'nfrSerialNumber',
    title :  this.$t('products.serialnumber')
    .toString(),
  },
  ];
  nfrProcessCompleteColumConfig:  TableColumnConfig[] = [{
    key : 'index',
    type : 'index',
  },
  {
    key: 'serialnumber',
    dataKey : 'serialnumber',
    title : this.$t('products.serialnumber')
    .toString(),
  },
  {
    key: 'eorderId',
    dataKey : 'eorderId',
    title : this.$t('nfr.requestid')
    .toString(),
  },
  ];
  created() {
    this.nfrProcessData =  [];
    this.data.selected.forEach((element : any) => {
      this.nfrProcessData.push(this.data.nfrServiceRowData[Number(element)]);
    });
  }
  submit() {
    this.submitted = true;
    let expiry = '';
    if (this.requestExp) {
      if (this.dateValue) {
        expiry = this.dateValue;
      } else {
        return;
      }
    }
    const serial : any = [];
    this.nfrProcessData.forEach((ele : any) => {
      serial.push({ serialNumber :  ele.nfrSerialNumber });
    });
    const request  = {
      nfrRequest: serial,
      expiryDate: expiry,
    };
    this.$store.dispatch('NfrServiceStoreStateModule/processNFR', request)
    .then((response : any) => {
      if (response.msgCode === 'MSWAPP:SUCCESS') {
        this.nfrProcessCompleteData =  response.content.nfrRes.map((ele: any, index : any) => {
          ele._key = index.toString();
          return ele;
        });
        this.nfrProcessCompleteMsg =  response.msgDesc;
        this.nfrProcessComplete =  true;
      } else {
        const message : InfoState = { infoMsg : response.msgDesc ,  infoType : 'failed' };
        this.$store.commit('enqueueMessage',  message);
      }
      this.$store.commit('stopLoading');
    });
  }
  closeDialog() {
    this.$emit('closeDialog', this.nfrProcessComplete ? true : false);
  }
  onDayClick2() {
    console.warn('day clicked..');
  }
}
